var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
// import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
// import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
// import SwapRightOutlined from '@ant-design/icons/SwapRightOutlined';
import { RangePicker as RCRangePicker } from 'bonree-picker';
import ControlCloseCircle from '../../_util/bonreeIcons/ControlCloseCircle';
import ControlDate from '../../_util/bonreeIcons/ControlDate';
import enUS from '../locale/en_US';
import { ConfigContext } from '../../config-provider';
import SizeContext from '../../config-provider/SizeContext';
import LocaleReceiver from '../../locale-provider/LocaleReceiver';
import { getRangePlaceholder } from '../util';
import { getTimeProps, Components, DEFAULT_TIME_ZONE } from '.';
export default function generateRangePicker(generateConfig) {
    class RangePicker extends React.Component {
        constructor() {
            super(...arguments);
            this.pickerRef = React.createRef();
            this.focus = () => {
                if (this.pickerRef.current) {
                    this.pickerRef.current.focus();
                }
            };
            this.blur = () => {
                if (this.pickerRef.current) {
                    this.pickerRef.current.blur();
                }
            };
            this.renderPicker = (contextLocale) => {
                const locale = Object.assign(Object.assign({}, contextLocale), this.props.locale);
                const { getPrefixCls, direction, getPopupContainer } = this.context;
                const _a = this.props, { prefixCls: customizePrefixCls, getPopupContainer: customGetPopupContainer, className, size: customizeSize, bordered = true, placeholder, allowClear = false, transitionName, timeZone = DEFAULT_TIME_ZONE, tzOffset } = _a, restProps = __rest(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder", "allowClear", "transitionName", "timeZone", "tzOffset"]);
                const { format = 'YYYY-MM-DD HH:mm', showTime, picker } = this.props;
                const prefixCls = getPrefixCls('picker', customizePrefixCls);
                let additionalOverrideProps = {};
                let timeFormat = 'HH:mm';
                if (typeof format === 'string' && format.includes('HH:mm:ss')) {
                    timeFormat = 'HH:mm:ss';
                }
                additionalOverrideProps = Object.assign(Object.assign({}, additionalOverrideProps), (showTime
                    ? getTimeProps(Object.assign({ format: timeFormat, picker, showNow: false }, showTime))
                    : {}));
                const rootPrefixCls = getPrefixCls();
                return (<SizeContext.Consumer>
          {size => {
                        const mergedSize = customizeSize || size;
                        return (<RCRangePicker separator={<span aria-label="to" className={`${prefixCls}-separator`}>
                    {/* <SwapRightOutlined /> */}~
                  </span>} ref={this.pickerRef} placeholder={getRangePlaceholder(picker, locale, placeholder)} suffixIcon={picker === 'time' ? <ClockCircleOutlined /> : <ControlDate />} clearIcon={<ControlCloseCircle />} prevIcon={<span className={`${prefixCls}-prev-icon`}/>} nextIcon={<span className={`${prefixCls}-next-icon`}/>} superPrevIcon={<span className={`${prefixCls}-super-prev-icon`}/>} superNextIcon={<span className={`${prefixCls}-super-next-icon`}/>} allowClear={allowClear} transitionName={transitionName || `${rootPrefixCls}-slide-up`} format={format} {...restProps} {...additionalOverrideProps} timeZone={timeZone} tzOffset={tzOffset} className={classNames({
                                [`${prefixCls}-${mergedSize}`]: mergedSize,
                                [`${prefixCls}-borderless`]: !bordered,
                            }, className)} locale={locale.lang} prefixCls={prefixCls} getPopupContainer={customGetPopupContainer || getPopupContainer} generateConfig={generateConfig} components={Object.assign({}, Components)} direction={direction}/>);
                    }}
        </SizeContext.Consumer>);
            };
        }
        render() {
            return (<LocaleReceiver componentName="DatePicker" defaultLocale={enUS}>
          {this.renderPicker}
        </LocaleReceiver>);
        }
    }
    RangePicker.contextType = ConfigContext;
    return RangePicker;
}
